export default __webpack_public_path__ + "static/media/img4.0805ff76.jpg";